/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
import{Uniform as r}from"../../../../webgl/Uniform.js";class o extends r{constructor(r,o,s){super(r,"int",1,(o,t,e)=>o.setUniform1iv(r,s(t,e)),o)}}export{o as IntegersPassUniform};
